import React from 'react';
import { XIcon } from 'lucide-react';
const pains = ["Planning tomorrow's groups on Sunday night — unpaid", "One table, four students, four goals that don't overlap", 'Winging a session and wondering if anyone made progress', 'Buying more materials, then never finding the one you need', 'Packets that need color printing, cutting and laminating', 'Your /r/ student waiting while the rest of the group does WH-questions', 'Therapy that feels watered down with 50 kids on your caseload', 'Paperwork eating the time you meant to plan with'];
export function PainGrid() {
  return <section aria-labelledby="pain-heading" className="w-full bg-white" data-id="element-187" data-mp="1bpb6eu2oxfzy">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-188" data-mp="17o93o39kelt8">
        <div className="text-center" data-id="element-189" data-mp="17pu05yffwetq">
          <p className="text-[12px] font-bold uppercase tracking-[1.6px] text-coral-deep" data-id="element-190" data-mp="363vnkwrsytel">
            The part nobody schedules for you
          </p>
          <h2 id="pain-heading" className="mt-3 font-display text-plum text-3xl sm:text-4xl md:text-5xl leading-tight" data-id="element-191" data-mp="322s502idej9o">
            If you run mixed groups, you know at least{' '}
            <span className="text-coral-deep" data-id="element-192" data-mp="3l9hlztgrlcsn">half of this list.</span>
          </h2>
        </div>

        <ul className="mt-9 grid gap-3 text-left sm:grid-cols-2 sm:gap-x-5" data-id="element-193" data-mp="37a83gn5366li">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-2xl border border-cream-dark bg-cream px-4 py-4 text-sm text-ink" data-id="element-194" data-mp="3bbtpoz3ifx8d">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-coral/15" data-id="element-195" data-mp="7si9n7xh7xxu">
                <XIcon className="h-3 w-3 text-coral-deep" aria-hidden="true" data-id="element-196" data-mp="3q56krukympnw" />
              </span>
              {pain}
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display text-2xl sm:text-3xl text-plum leading-tight" data-id="element-197" data-mp="qjrirg3c4kow">
          How many more Sunday nights do you want to spend planning groups?
        </p>
      </div>
    </section>;
}